import React from 'react';

export default function Image({ src, alt, width, height, className, style, priority, fill, ...props }: any) {
  const mergedStyle = fill
    ? { position: 'absolute' as const, top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' as const, ...style }
    : style;
  return React.createElement('img', {
    src: typeof src === 'object' && src?.src ? src.src : src,
    alt: alt || '',
    width: fill ? undefined : width,
    height: fill ? undefined : height,
    className,
    style: mergedStyle,
    ...props,
  });
}

export { Image };
